import styled from 'styled-components'

import { TradePairHoldersTable } from '../trade-tables/trade-pair-holders-table'

import { TradeHoldersCharts } from './trade-holders-charts'

import type { PairModel } from '@root/entities/pair'

type TradeHoldersTabProps = {
  pair: PairModel
}

export const TradeHoldersTab = (props: TradeHoldersTabProps) => {
  return (
    <Root>
      <TradeHoldersCharts pair={props.pair} />
      <Table>
        <TradePairHoldersTable pair={props.pair} />
      </Table>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
`
const Table = styled.div`
  border-top: 1px solid var(--background-3);
`
